<template>
  <v-container>
    <v-row>
      <v-col sm="12">
        {{ payload.titulo }}
      </v-col>
    </v-row>
    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          Anexos
        </v-tab>

        <v-tab-item>
          <v-data-table
            :headers="headersAnexos"
            :items="payload.anexos"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.download="{ item }">
              <v-btn
                outlined
                color="primary"
                class="ml-3"
                @click="downloadAnexo(item)"
              >
                <span>Download</span>
              </v-btn>
            </template>

            <template slot="no-data">
              <span> Nenhum anexo retornado </span>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { ReportAPIPublic } from "@/modules/report";
import { paymentReportManagementAPI } from "@/modules/payment-management";

export default {
  components: {},
  data() {
    return {
      tiposExecucao: [
        { name: "Presencial", value: 1 },
        { name: "Remoto", value: 2 },
      ],
      payload: {
        arquivos: [],
        convidadosRelatorio: [],
        tarefas: [],
        tipoExecucaoRelatorio: { name: "Presencial", values: 1 },
      },
      membros: [],
      headers: [
        { text: "Tarefa", value: "municipioTarefa.nome" },
        { text: "Cumprida", value: "cumprida" },
        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
      ],
      headersConvidados: [
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
        { text: "E-mail", value: "email" },
        { text: "Presente", value: "presente" },
      ],
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
      estado: this.$store.state.uf,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    get() {
      this.setLoading(true);
      ReportAPIPublic.getById(this.$route.params.relatorio)
        .then((resp) => {
          this.payload = resp.data;
          this.payload.tipoExecucaoRelatorio = this.tiposExecucao.find(
            (item) => item.value === this.payload.tipoExecucaoRelatorioId
          );
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório");
        });
    },
    downloadAnexo(evidencia) {
      paymentReportManagementAPI
        .downloadAnexo(evidencia.relatorioAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter Anexo");
        });
    },
  },
  mounted() {
    this.get();
    // this.setConsultorCondutorMunicipio(this.$route.params.id)
    // this.setConsultorEspecialistaMunicipio(this.$route.params.id)
    // this.setAnalistaMunicipio(this.$route.params.id)
    // this.setADMunicipio(this.$route.params.id)
  },
  computed: {},
};
</script>
